import { themr } from '@nextiva/analytics-lib';
import { Tooltip } from '@nextiva/next-ui';
import cx from 'classnames';
import React from 'react'; // nextiva

import tooltipIcon from "../../assets/tooltip-icon.png"; // own

import Styles from "./XbertTooltip.css";

var renderTipContent = function renderTipContent(tipContent) {
  return React.createElement(React.Fragment, null, React.createElement("h4", null, "XBert tip:"), tipContent);
};

var XbertTooltip = function XbertTooltip(props) {
  var tipId = props.tipId,
      tipItem = props.tipItem,
      tipClass = props.tipClass,
      _a = props.tipContent,
      tipContent = _a === void 0 ? '' : _a,
      theme = props.theme;
  return React.createElement(Tooltip, {
    id: tipId,
    delay: 700,
    placement: "bottom",
    text: renderTipContent(tipContent),
    popoverClassName: cx(theme.xbertTooltip, tipClass)
  }, tipItem || React.createElement("img", {
    src: tooltipIcon,
    alt: "Tooltip"
  }));
};

export default themr(XbertTooltip, Styles);